export type Role = 'WATCH' | 'OBSERVER' | 'PRESENTER' | 'DIAL_IN' | 'READONLY' | 'CONTROLLER'
export const READONLY: Role = 'READONLY'
export const WATCH: Role = 'WATCH'
export const OBSERVER: Role = 'OBSERVER'
export const PRESENTER: Role = 'PRESENTER'
export const DIAL_IN: Role = 'DIAL_IN'
export const CONTROLLER: Role = 'CONTROLLER'

export default {
  READONLY,
  WATCH,
  OBSERVER,
  PRESENTER,
  DIAL_IN,
  CONTROLLER
}
